<template>
  <div
    class="flex h-full w-full overflow-y-auto p-1.5"
    :class="[{ 'shadow-lg': !config.isEmbedded }, isMobile ? 'flex-col bg-white' : 'bg-light-grey']"
  >
    <platform-nav-bar v-if="hasVisibleNavItems" />
    <main
      data-cy="borrower-platform-main"
      class="flex h-full w-full flex-col rounded-lg bg-white"
      :class="
        isLoggedIn &&
        selectedApplication && [isMobile ? 'max-h-[calc(100%-3rem)]' : 'max-w-[calc(100%-8rem)]']
      "
    >
      <platform-header v-if="!isBrandingLoading && screenHasHeader" />
      <platform-contact
        v-if="isMobile && selectedApplication?.funding_advisor"
        class="absolute right-5 bottom-10"
        :advisor="selectedApplication.funding_advisor"
      />
      <div class="relative h-full w-full overflow-auto">
        <slot></slot>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import PlatformHeader from "@/components/platform/PlatformHeader.vue";
import config from "@/config";
import PlatformContact from "@/components/platform/PlatformContact.vue";
import useApplicationsState from "@/composables/state/applicationsState";
import { useResponsive } from "@/composables/common";
import usePlatformScreenState from "@/composables/state/platformScreenState";
import useBrandingState from "@/composables/state/brandingState";
import PlatformNavBar from "@/components/platform/PlatformNavBar.vue";
import useAuthState from "@/composables/state/authState";

const { isMobile } = useResponsive();
const { selectedApplication } = useApplicationsState();
const { screenHasHeader, visibleTabs } = usePlatformScreenState();
const { isBrandingLoading } = useBrandingState();
const { isLoggedIn } = useAuthState();

const hasVisibleNavItems = computed(() => visibleTabs.value.length > 0);
</script>
